import React, { useEffect, useState } from "react";
import { Accordion, Form } from "react-bootstrap";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { FormattedMessage, FormattedNumber, useIntl } from "react-intl";
import { btnTranslate, employeeExperienceTranslate } from "../../../../i18n/translatedMessages";

const EducationAccordion = ({ itemActive, formations, handleChange, handleSend }) => {
  const lang = useIntl();
  const [isChecked, setIsChecked] = useState([]);
  const [activeState, setActiveState] = useState(itemActive);
  useEffect(() => {
    // Función auxiliar para actualizar el arreglo isChecked
    const updateIsChecked = (formations) => {
      const newIsChecked = formations.map((el) => el.departure_date === "En curso");
      setIsChecked(newIsChecked);
    };

    // Llamada a la función auxiliar
    updateIsChecked(formations);
  }, []);

  useEffect(() => {
    setActiveState(itemActive.toString());
  }, [itemActive, formations]);

  useEffect(() => {}, [activeState]);

  const handleCheckboxChange = (index) => {
    const updatedCheckboxValues = [...isChecked]; // Crea una copia del estado actual
    updatedCheckboxValues[index] = !updatedCheckboxValues[index]; // Actualiza el valor del checkbox en el índice especificado
    setIsChecked(updatedCheckboxValues); // Actualiza el estado con los nuevos valores de los checkboxes
  };

  return (
    <>
      <Accordion activeKey={activeState.toString()} flush>
        {formations.map((el, i) => {
          return (
            <div key={i}>
              <Accordion.Item
                className="shadow my-3"
                onClick={() => setActiveState(i)}
                eventKey={i.toString()}
              >
                <Accordion.Header>
                  #{i + 1} - {formations[i].university ? formations[i].university : ""}
                </Accordion.Header>
                <Accordion.Body>
                  <div className="row d-flex justify-content-center">
                    <div className="col-4">
                      <Form.Group className="mb-3">
                        <Form.Label>
                          {employeeExperienceTranslate.formationEENameUniversity}
                        </Form.Label>
                        <Form.Control
                          className="mt-0"
                          type="text"
                          value={formations[i].name ? formations[i].name : ""}
                          name="name"
                          data-index={i}
                          onChange={(e) => handleChange(e)}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-4">
                      <Form.Group className="mb-3">
                        <Form.Label>{employeeExperienceTranslate.formationEECourse}</Form.Label>
                        <Form.Control
                          className="mt-0"
                          type="text"
                          value={formations[i].university ? formations[i].university : ""}
                          name="university"
                          data-index={i}
                          onChange={(e) => handleChange(e)}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-4">
                      <Form.Group className="mb-3">
                        <Form.Label>{employeeExperienceTranslate.formationEEType}</Form.Label>
                        <Form.Select
                          className="border-primary-inputs"
                          value={el.formation_level_id ? el.formation_level_id : "1"}
                          name="formation_level_id"
                          data-index={i}
                          onChange={(e) => handleChange(e)}
                        >
                          <FormattedMessage id="historicProfessionalEEOption0">
                            {(msg) => <option>{msg}</option>}
                          </FormattedMessage>
                          <FormattedMessage id="formationEEOption1">
                            {(msg) => <option value="1">{msg}</option>}
                          </FormattedMessage>
                          <FormattedMessage id="formationEEOption2">
                            {(msg) => <option value="2">{msg}</option>}
                          </FormattedMessage>
                          <FormattedMessage id="formationEEOption3">
                            {(msg) => <option value="3">{msg}</option>}
                          </FormattedMessage>
                          <FormattedMessage id="formationEEOption4">
                            {(msg) => <option value="4">{msg}</option>}
                          </FormattedMessage>
                          <FormattedMessage id="formationEEOption5">
                            {(msg) => <option value="5">{msg}</option>}
                          </FormattedMessage>
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-4 d-flex align-content-center justify-content-center">
                      <Form.Group className="mb-3 d-flex flex-column align-items-center">
                        <Form.Label>
                          {lang.locale === "PT-BR" ? "" : "¿"}
                          {employeeExperienceTranslate.formationEECurrentlyStuding}?
                        </Form.Label>
                        <Form.Check
                          id={`isStudying${i}`}
                          className="mt-2"
                          type="checkbox"
                          label={lang.locale === "PT-BR" ? "Sim" : "Sí"}
                          checked={isChecked[i]}
                          onChange={() => handleCheckboxChange(i)}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-4">
                      <Form.Group className="mb-3">
                        <Form.Label>
                          {employeeExperienceTranslate.formationEEEntryDateCourse}
                        </Form.Label>
                        <Form.Control
                          className="border-primary-inputs"
                          type="date"
                          name="entry_date"
                          data-index={i}
                          value={
                            el.entry_date
                              ? new Date(el.entry_date).toISOString().split("T")[0]
                              : "2000-01-01"
                          }
                          onChange={(e) => handleChange(e)}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-4">
                      {isChecked[i] ? null : (
                        <Form.Group className="mb-3">
                          <Form.Label>
                            {employeeExperienceTranslate.formationEELeaveDateCourse}
                          </Form.Label>
                          <Form.Control
                            className="border-primary-inputs"
                            type="date"
                            name="departure_date"
                            data-index={i}
                            value={
                              el.departure_date !== "En curso"
                                ? new Date(el.departure_date).toISOString().split("T")[0]
                                : "2014-01-01"
                            }
                            onChange={(e) => handleChange(e)}
                          />
                        </Form.Group>
                      )}
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-end">
                    <div style={{ maxWidth: "150px" }}>
                      <button
                        className="btn rounded-pill addEmployeeInfo-btn"
                        onClick={() => handleSend()}
                      >
                        {btnTranslate.saveButton} <AiOutlinePlusCircle size={25} />
                      </button>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </div>
          );
        })}
      </Accordion>
    </>
  );
};

export default EducationAccordion;
